import { ref } from 'vue';

const transactionId = ref('');
const stripeChargeId = ref('');
const unpaidRidesPhoneNumber = ref('');
const unpaidGroceriesPhoneNumber = ref('');
const unpaidServicesPhoneNumber = ref('');
const unpaidGourmetPhoneNumber = ref('');

export const usePayment = () => {
  const setTransactionId = (value: string) => {
    transactionId.value = value;
  };

  const setStripeChargeId = (value: string) => {
    stripeChargeId.value = value;
  };

  const setUnpaidRidesPhoneNumber = (phoneNumber: string) => {
    unpaidRidesPhoneNumber.value = phoneNumber;
  };

  const setUnpaidGroceriesPhoneNumber = (phoneNumber: string) => {
    unpaidGroceriesPhoneNumber.value = phoneNumber;
  };

  const setUnpaidServicesPhoneNumber = (phoneNumber: string) => {
    unpaidServicesPhoneNumber.value = phoneNumber;
  };

  const setUnpaidGourmetPhoneNumber = (phoneNumber: string) => {
    unpaidGourmetPhoneNumber.value = phoneNumber;
  };

  return {
    transactionId,
    stripeChargeId,
    unpaidRidesPhoneNumber,
    unpaidGroceriesPhoneNumber,
    unpaidServicesPhoneNumber,
    unpaidGourmetPhoneNumber,

    setTransactionId,
    setStripeChargeId,
    setUnpaidRidesPhoneNumber,
    setUnpaidGroceriesPhoneNumber,
    setUnpaidServicesPhoneNumber,
    setUnpaidGourmetPhoneNumber,
  };
};
